var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum } from "class-validator";
import { bitmaskFromEnums, enumsFromBitmask } from "./bitmask";
import { reverseMap } from "./utils";
export var ConsentDataResourceScope;
(function (ConsentDataResourceScope) {
    ConsentDataResourceScope["CONTACT_INFO"] = "CONTACT_INFO";
    ConsentDataResourceScope["MEDICATIONS"] = "MEDICATIONS";
    ConsentDataResourceScope["ALLERGIES"] = "ALLERGIES";
    ConsentDataResourceScope["DIAGNOSES"] = "DIAGNOSES";
    ConsentDataResourceScope["LABS"] = "LABS";
    ConsentDataResourceScope["DEMOGRAPHICS"] = "DEMOGRAPHICS";
    ConsentDataResourceScope["CLINICAL_NOTES"] = "CLINICAL_NOTES";
    ConsentDataResourceScope["VISITS"] = "VISITS";
    ConsentDataResourceScope["DIAGNOSTIC_REPORTS"] = "DIAGNOSTIC_REPORTS";
    ConsentDataResourceScope["CLINICAL_VITALS"] = "CLINICAL_VITALS";
    ConsentDataResourceScope["PROCEDURES"] = "PROCEDURES";
    ConsentDataResourceScope["IMMUNIZATIONS"] = "IMMUNIZATIONS";
    ConsentDataResourceScope["IMAGING"] = "IMAGING";
    ConsentDataResourceScope["TREATMENT_PLAN"] = "TREATMENT_PLAN";
    ConsentDataResourceScope["GENOMIC_DATA"] = "GENOMIC_DATA";
    ConsentDataResourceScope["FAMILY_HISTORY"] = "FAMILY_HISTORY";
    ConsentDataResourceScope["SOCIAL_HISTORY"] = "SOCIAL_HISTORY";
    ConsentDataResourceScope["ADMINISTRATIVE_AND_BILLING"] = "ADMINISTRATIVE_AND_BILLING";
})(ConsentDataResourceScope || (ConsentDataResourceScope = {}));
export var ConsentDataSensitivityScope;
(function (ConsentDataSensitivityScope) {
    ConsentDataSensitivityScope["NORMAL"] = "NORMAL";
    ConsentDataSensitivityScope["HIV_OR_STI"] = "HIV_OR_STI";
    ConsentDataSensitivityScope["SUBSTANCE_USE_OR_DRUG_ABUSE"] = "SUBSTANCE_USE_OR_DRUG_ABUSE";
    ConsentDataSensitivityScope["MENTAL_HEALTH"] = "MENTAL_HEALTH";
    ConsentDataSensitivityScope["GENETIC_TESTING"] = "GENETIC_TESTING";
    ConsentDataSensitivityScope["REPRODUCTIVE_HEALTH_DATA"] = "REPRODUCTIVE_HEALTH_DATA";
    ConsentDataSensitivityScope["PSYCHOTHERAPY_NOTES"] = "PSYCHOTHERAPY_NOTES";
    ConsentDataSensitivityScope["SUD_PART_2"] = "SUD_PART_2";
    ConsentDataSensitivityScope["SICKLE_CELL"] = "SICKLE_CELL";
})(ConsentDataSensitivityScope || (ConsentDataSensitivityScope = {}));
export class ConsentDataScope {
}
__decorate([
    ApiProperty({
        enum: ConsentDataResourceScope,
        enumName: "ConsentDataResourceScope",
    }),
    IsEnum(ConsentDataResourceScope)
], ConsentDataScope.prototype, "resourceScope", void 0);
__decorate([
    ApiProperty({
        enum: ConsentDataSensitivityScope,
        enumName: "ConsentDataSensitivityScope",
    }),
    IsEnum(ConsentDataSensitivityScope)
], ConsentDataScope.prototype, "sensitivityScope", void 0);
export function consentDataScopesFromComponentScopes(resourceScopes, sensitivityScopes) {
    return resourceScopes.flatMap((resourceScope) => sensitivityScopes.map((sensitivityScope) => ({ resourceScope, sensitivityScope })));
}
const toBlockchainConsentDataResourceScopeOrdinal = {
    [ConsentDataResourceScope.CONTACT_INFO]: 0,
    [ConsentDataResourceScope.MEDICATIONS]: 1,
    [ConsentDataResourceScope.ALLERGIES]: 2,
    [ConsentDataResourceScope.DIAGNOSES]: 3,
    [ConsentDataResourceScope.LABS]: 4,
    [ConsentDataResourceScope.DEMOGRAPHICS]: 5,
    [ConsentDataResourceScope.CLINICAL_NOTES]: 6,
    [ConsentDataResourceScope.VISITS]: 7,
    [ConsentDataResourceScope.DIAGNOSTIC_REPORTS]: 8,
    [ConsentDataResourceScope.CLINICAL_VITALS]: 9,
    [ConsentDataResourceScope.PROCEDURES]: 10,
    [ConsentDataResourceScope.IMMUNIZATIONS]: 11,
    [ConsentDataResourceScope.IMAGING]: 12,
    [ConsentDataResourceScope.TREATMENT_PLAN]: 13,
    [ConsentDataResourceScope.GENOMIC_DATA]: 14,
    [ConsentDataResourceScope.FAMILY_HISTORY]: 15,
    [ConsentDataResourceScope.SOCIAL_HISTORY]: 16,
    [ConsentDataResourceScope.ADMINISTRATIVE_AND_BILLING]: 17,
};
const fromBlockchainConsentDataResourceScopeOrdinal = reverseMap(toBlockchainConsentDataResourceScopeOrdinal);
const toBlockchainConsentDataSensitivityScopeOrdinal = {
    [ConsentDataSensitivityScope.NORMAL]: 0,
    [ConsentDataSensitivityScope.HIV_OR_STI]: 1,
    [ConsentDataSensitivityScope.SUBSTANCE_USE_OR_DRUG_ABUSE]: 2,
    [ConsentDataSensitivityScope.MENTAL_HEALTH]: 3,
    [ConsentDataSensitivityScope.GENETIC_TESTING]: 4,
    [ConsentDataSensitivityScope.REPRODUCTIVE_HEALTH_DATA]: 5,
    [ConsentDataSensitivityScope.PSYCHOTHERAPY_NOTES]: 6,
    [ConsentDataSensitivityScope.SUD_PART_2]: 7,
    [ConsentDataSensitivityScope.SICKLE_CELL]: 8,
};
const fromBlockchainConsentDataSensitivityScopeOrdinal = reverseMap(toBlockchainConsentDataSensitivityScopeOrdinal);
export function fromBlockchainConsentDataResourceScope(blockchainResourceScope) {
    return enumsFromBitmask(blockchainResourceScope, fromBlockchainConsentDataResourceScopeOrdinal);
}
export function toBlockchainConsentDataResourceScope(scopes) {
    return bitmaskFromEnums(scopes, toBlockchainConsentDataResourceScopeOrdinal);
}
export function fromBlockchainConsentDataSensitivityScope(blockchainSensitivityScope) {
    return enumsFromBitmask(blockchainSensitivityScope, fromBlockchainConsentDataSensitivityScopeOrdinal);
}
export function toBlockchainConsentDataSensitivityScope(scopes) {
    return bitmaskFromEnums(scopes, toBlockchainConsentDataSensitivityScopeOrdinal);
}
